import React, { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Divider } from '@ds';
import { AdminFormSection } from '@ui';
import { TMDXFile } from '@/api/apis/files';
import { getFullName } from '@/utils/helpers';
import { CreateOpoContactFormValues } from './types';
import { MainOpoContactForm } from './components/MainOpoContactForm';
import { OpoContactInviteSection } from './components/OpoContactInviteSection';

type Props = {
  isReadOnly?: boolean;
  isPrimary?: boolean;
  onInviteAsUserChange?: (value: boolean) => void;
};

export const OpoContactDetailsSection = React.memo(
  ({ isReadOnly = false, isPrimary = false, onInviteAsUserChange }: Props) => {
    const { control, setValue } = useFormContext<CreateOpoContactFormValues>();

    const photoPath = useWatch({ control, name: 'photoPath' });
    const firstName = useWatch({ control, name: 'firstName' });
    const lastName = useWatch({ control, name: 'lastName' });

    const onImageChange = useCallback(
      (file: TMDXFile) => {
        setValue('photo', file, { shouldDirty: true });
      },
      [setValue],
    );

    return (
      <AdminFormSection
        title="OPO Contact Details"
        withAvatar
        isPrimary={isPrimary}
        isReadOnly={isReadOnly}
        imageUrl={photoPath ?? undefined}
        onImageChange={onImageChange}
        name={getFullName(firstName, lastName)}
      >
        <MainOpoContactForm isReadOnly={isReadOnly} />

        <Divider orientation="horizontal" />

        <OpoContactInviteSection isReadOnly={isReadOnly} onInviteAsUserChange={onInviteAsUserChange} />
      </AdminFormSection>
    );
  },
);

OpoContactDetailsSection.displayName = 'OpoContactDetailsSection';
